import { createContext } from 'react';

export interface PageHead {
    title: string;
    description: string;
    structuredData?: object[];
}

export const PageHeadContext = createContext<PageHead | null>(null);
